__turbopack_context__.v({
  "counterOfferModalSuccessButton": "PQho7q_counterOfferModalSuccessButton",
  "counterOfferModalSuccessContainer": "PQho7q_counterOfferModalSuccessContainer",
  "counterOfferModalSuccessText": "PQho7q_counterOfferModalSuccessText",
});
